import { useServiceFactory } from '@euler/services/factory';
import { useCallback } from 'react';
import { CaseListState, useCaseList } from './useCaseList';

/** A collection is a short authored list: one search fetches all of it. */
const kCollectionLimit = 100;

/** Every case of a collection, in its authored order. */
export function useCollectionCases(slug: string): {
  state: CaseListState;
  reload: () => void;
} {
  const { coachingService } = useServiceFactory();
  const load = useCallback(
    async () =>
      (
        await coachingService.searchCases({
          collection: slug,
          limit: kCollectionLimit,
        })
      ).cases,
    [coachingService, slug],
  );
  return useCaseList(load, 'collection cases');
}
